var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgSleep = function SvgSleep(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M8.2 8.647a3.28 3.28 0 0 0 1.134-2.48 3.333 3.333 0 0 0-6.667 0A3.28 3.28 0 0 0 3.8 8.647 5.33 5.33 0 0 0 .667 13.5.666.666 0 1 0 2 13.5a4 4 0 0 1 8 0 .667.667 0 0 0 1.334 0A5.33 5.33 0 0 0 8.2 8.647M6 8.167a2 2 0 1 1 0-4 2 2 0 0 1 0 4m6.494.213A3.334 3.334 0 0 0 10 2.833a.667.667 0 0 0 0 1.334 2 2 0 0 1 1.731 2.997 2 2 0 0 1-.73.73.666.666 0 0 0-.034 1.133l.26.173.087.047A4.67 4.67 0 0 1 13.98 13.5a.667.667 0 0 0 1.334 0 6 6 0 0 0-2.82-5.12"
  })));
};
export default SvgSleep;